import { Badge, Center } from "@chakra-ui/react";
import { NodeProps } from "reactflow";
import { WIDGET_CONTAINER_CLASS } from "../../../../../common/constants/campaign";
import { EdgeLabelNodeArgs } from "../../../../../common/types/flow";
import { FlowStepSourceHandle, FlowStepTargetHandle } from "./FlowHandle";

export default function EdgeLabel({
  data: { label },
}: NodeProps<EdgeLabelNodeArgs>) {
  return (
    <Center w="sm" className={WIDGET_CONTAINER_CLASS}>
      <Badge
        bg="gray.300"
        px={2}
        py={1}
        bgColor="white"
        fontSize="10px"
        border="1px solid"
        borderColor="gray.300"
        color="gray.500"
        maxW="100%"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
      >
        <FlowStepTargetHandle />
        {label}
        <FlowStepSourceHandle />
      </Badge>
    </Center>
  );
}
